import React from "react";

import withSessionHandling, {
  type SessionHandlerProps,
} from "@/context/auth/withSessionHandling";
import { useRouterSearchParams } from "@/hooks/router";
import ImageDetailsScreen from "@/screens/Image/ImageDetailsScreen";
import type { UserLikableImageMedia } from "@/schemas/user/image";

function Screen(props: SessionHandlerProps): React.JSX.Element {
  const imageMedia = useRouterSearchParams("imageMedia");
  const parsedImageMedia = JSON.parse(imageMedia) as UserLikableImageMedia;

  return (
    <ImageDetailsScreen
      {...props}
      imageMedia={parsedImageMedia}
      key={parsedImageMedia.image.id}
    />
  );
}

export default withSessionHandling(Screen);
